import { Model, Attr, HasOne, HasMany } from 'spraypaint';
import { Legislation, Organisation, User, Recipe } from '@/api';
import i18n from '@/plugins/vue-i18n';
import ApplicationRecord from '../ApplicationRecord';

export enum ReportStatus {
  'Pending' = 1,
  'Failed' = 2,
  'Successful' = 3,
}

@Model()
export default class OrganisationalRecipeReport extends ApplicationRecord {
  static jsonapiType = 'organisational-recipe-reports';

  static listHeaders() {
    return [
      {
        text: i18n.t('common.labels.created'),
        value: 'created',
      },
      {
        text: i18n.t('common.labels.legislation'),
        value: 'legislation',
      },
      {
        text: i18n.t('legislations.labels.effectiveFrom'),
        value: 'effectiveFrom',
      },
      {
        text: i18n.t('reports.labels.notes'),
        value: 'notes',
      },
      {
        value: 'file',
        width: 64,
      },
    ];
  }

  static scopeFactory() {
    return OrganisationalRecipeReport.includes([]);
  }

  @Attr() created: string;

  @Attr() modified: string;

  @Attr() status: ReportStatus;

  @Attr() file: string;

  @Attr() notes: string;

  @HasOne() createdBy: User;

  @HasOne() modifiedBy: User;

  @HasOne() organisation: Organisation;

  @HasOne() legislation: Legislation;

  @HasMany() recipes: Recipe;
}
